import { useApolloClient } from '@apollo/client';
import { useMetaMask } from 'metamask-react';
import useFeature from '~/client/hooks/feature/useFeature';
import useRouter from '~/client/hooks/router/useRouter';
import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import {
  MetamaskAuthMutationFastSignupMutationVariables,
  useMetamaskAuthMutationFastSignup,
} from './graphql/MetamaskAuthenticateFastSignup.generated';
import getAccessCode from '../../../modules/helpers/getAccessCode';
import {
  MetamaskAuthMutationVariables,
  useMetamaskAuthMutation,
} from '../graphql/MetamaskAuthMutation.generated';

type Args = {
  address: string;
  refCode: string;
  refAff: string;
  friendRef: string;
  otp?: string;
  cid: string;
  path: string;
  values: Omit<MetamaskDepositFormValues, 'dateOfBirth'> & {
    dateOfBirth?: number;
    accessCode?: string;
    ethAddress?: string;
  };
  redirectUrl: string;
};

const useMetaMaskUserFastSignup = () => {
  const [metaMaskAuthFastSignup] = useMetamaskAuthMutationFastSignup();
  const { ethereum } = useMetaMask();
  const { asPath } = useRouter();
  const client = useApolloClient();
  const { site } = useSite();
  const { code: language } = useLanguage();
  const isFastSignUpEnabled = useFeature('isFastSignUpEnabled') ?? false;
  const [metamaskAuth, { loading }] = useMetamaskAuthMutation();

  const handleMetamaskAuthFastSignup = async ({
    refCode,
    refAff,
    friendRef,
    cid,
    values,
    path,
    address,
    otp,
  }: Args) => {
    const accessCode = await getAccessCode({
      client,
      address,
      site,
    });

    const signature = await ethereum.request({
      method: 'personal_sign',
      params: [`${site}: ${accessCode}`, address],
    });

    const optionalVariables = asPath.includes(path)
      ? {
          username: values.username,
          password: values.password,
          email: values.email,
          phone: values.phone,
          offers: values.offers,
          dateOfBirth: values.dateOfBirth,
          language,
          refAff,
          refCode,
          friendRef,
          cid,
        }
      : {};
    const variables:
      | MetamaskAuthMutationFastSignupMutationVariables
      | MetamaskAuthMutationVariables = {
      input: {
        ...optionalVariables,
        address,
        signature: signature as string,
        site,
        otp,
      },
    };
    if (isFastSignUpEnabled) {
      const { data } = await metaMaskAuthFastSignup({ variables });

      return data?.userManagementMetamaskAuthenticateFastSignup ?? {};
    }
    const { data } = await metamaskAuth({ variables });

    return data?.userManagementMetamaskAuthenticate ?? {};
  };
  return { handleMetamaskAuthFastSignup, loading };
};

export default useMetaMaskUserFastSignup;
